import { forwardRef, useContext } from "react"
import classNames from "classnames"

import { DataTableContext } from "./DataTable"

import RowSelector from "./RowSelector"
import TitleCell from "./TitleCell"

const TitleRow = forwardRef((props, ref) => {
  const {
    columns,
    gridTemplateColumns,
    canSelectRow,
    allRowsSelected,
    hasFrozenColumns,
    onSelectAllChanged,
    showRowNumbers,
  } = useContext(DataTableContext)

  const rowClasses = classNames(
    "sticky top-0 z-30 group/row datatable-title-row box-border inline-grid min-w-full items-center rounded-t-md border-b bg-white text-sm text-neutral-4"
  )

  const ordinalClasses = classNames(
    "flex w-[30px] justify-center items-center h-full bg-white z-10",
    { "sticky left-0": hasFrozenColumns }
  )

  const rowSelectorClasses = classNames(
    "flex w-[30px] justify-center items-center h-full bg-white z-10",
    {
      sticky: hasFrozenColumns,
      "left-0": hasFrozenColumns && !showRowNumbers,
      "left-[30px]": hasFrozenColumns && showRowNumbers,
    }
  )

  return (
    <div className={rowClasses} style={{ gridTemplateColumns }} ref={ref}>
      {showRowNumbers && <div className={ordinalClasses} />}
      {canSelectRow && (
        <RowSelector
          id="select-all"
          className={rowSelectorClasses}
          selected={allRowsSelected}
          onRowSelectionChanged={onSelectAllChanged}
        />
      )}
      {columns.map((column, n) => {
        return <TitleCell key={n} column={column} />
      })}
    </div>
  )
})

export default TitleRow
